import React from "react";
import { Link } from "react-router-dom";

function ItemMenuCategory(props){
    return (
        <Link to={'category-select/'+props.id}>{props.name}</Link>
    );
}
export default ItemMenuCategory;